import { Api } from '@axiom/ui';
import type { Account, AccountIntake, AfcSubmission } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class AccountIntakeApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  readAccountIntake(
    accountId: Account['id'],
    query?: { submissionId?: AfcSubmission['id'] }
  ) {
    return super.read<{ data: AccountIntake | null }>({
      endpoint: `/intake/details/account/${accountId}`,
      query: query ?? undefined,
      method: 'GET',
    });
  }

  async updateAccountIntake(
    accountId: Account['id'],
    body: Partial<AccountIntake>,
    query?: { submissionId: AfcSubmission['id'] }
  ) {
    return super.write<{ data: null }>({
      endpoint: `/intake/details/account/${accountId}`,
      method: 'PATCH',
      query: query ?? undefined,
      body,
    });
  }

  async refreshAccountIntake(accountId: Account['id']) {
    return super.invalidate(`/intake/details/account/${accountId}`);
  }
}

export const AccountIntakeApi = new AccountIntakeApiClass();
